import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { get_bulk_settings } from "../../Component/Helper";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { ApiList } from "../../Api/ApiList";
import { fetch_data_from_api_from_query } from "../../Api/APICalls";
import Loader from "../../Component/Loader";
import { useLocation } from "react-router-dom";
import SearchBar from "../../Component/SearchBar/SearchBar";
import "./my-catalogue-new-arrival-page.css";
import My_Catalogue_New_Arrival_Card from "./components/my-catalogue-new-arrival-card";

export default function My_Catalogue_New_Arrival_Page() {
  const { mycatalogue_listing_row_size, my_catalogue_label } = get_bulk_settings([
    "mycatalogue_listing_row_size",
    "my_catalogue_label"
  ]);
  const location = useLocation();
  const is_new_arrival = location.pathname.includes("/new-arrival") ? "1" : "0";
  const [product_count, set_product_count] = useState(25);
  const [page, set_page] = useState(0);
  const [search_by, set_search_by] = useState("");

  const handle_search = (value) => {
    set_search_by(value);
  };

  const my_catalouge_new_arrival_query = useInfiniteQuery({
    queryKey: [ApiList.MyCatalogue, is_new_arrival, search_by],
    queryFn: ({ pageParam }) => {
      set_page(pageParam);
      return fetch_data_from_api_from_query(
        ApiList.MyCatalogue,
        ApiList.MyCatalogue,
        {
          session_id: "0",
          page: !!search_by ? "0" : pageParam,
          page_size: mycatalogue_listing_row_size || "25",
          is_new_arrival,
          search_by,
        }
      );
    },
    initialPageParam: 0,
    getNextPageParam: () => {
      const total_page = Math.floor(
        parseInt(product_count) / parseInt(mycatalogue_listing_row_size || "25")
      );

      return total_page > page ? page + 1 : undefined;
    },
  });

  useEffect(() => {
    fetch_data_from_api_from_query(ApiList.MyCatalogue, ApiList.MyCatalogue, {
      session_id: "0",
      page: 0,
      page_size: "100",
      is_new_arrival,
    }).then((res) => {
      set_product_count(res?.length);
    });
    set_search_by("")
  }, [is_new_arrival]);

 

 

  return (
    <section className="my-catalogue-new-arrival-page">
      <div className="search-bar-container">
        <SearchBar handle_search_key={handle_search} placeholder="Search" />
      </div>
      <div className="product_title">

      <h2>{is_new_arrival === "1" ? "New Arrival" : my_catalogue_label}</h2>
      </div>
      {my_catalouge_new_arrival_query.isLoading ? (
        <Loader isLoading={true} />
      ) : (
        <div className="my-catalogue-new-arrival-card-container">
            {
                my_catalouge_new_arrival_query.data.pages.flat()?.map(my_catalouge_new_arrival => <My_Catalogue_New_Arrival_Card key={my_catalouge_new_arrival.id} {...my_catalouge_new_arrival}/>)
            }
          
          
        </div>
      )}
    </section>
  );
}
